/** @format */

import { Injectable, TransferState, inject, makeStateKey } from '@angular/core';

import { Checkout } from '@cart-checkout/data-access/interfaces';
import { Environment } from '@shared/data-access/interfaces';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyPointCalculationDao {
  private readonly DEFAULT_HEADERS: Record<string, string>;
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: Environment = inject(Environment);
  private readonly state: TransferState = inject(TransferState);

  constructor() {
    this.DEFAULT_HEADERS = {
      Accept: 'application/json;',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      secret_key: this.environment.api.loyaltyPointsCalculationService.secretKey,
      partner_key: this.environment.api.loyaltyPointsCalculationService.partnerKey,
    };
  }

  public getPointCalculation$(checkout: Checkout, forcePCS?: boolean): Observable<any> {
    const STATE_KEY = makeStateKey('scorecardPoints');

    // Attempt to get the state by key
    const stateData: any = this.state.get(STATE_KEY, null);

    if (stateData && !forcePCS) {
      // Return the existing state
      return new Observable((observer) => {
        observer.next(stateData);
        observer.complete();
      });
    }

    const url = `${this.environment.baseUrls.loyaltyPointsCalculationService}/v1/Points/order`;
    const httpOptions = {
      headers: this.DEFAULT_HEADERS,
      withCredentials: true,
    };

    return this.http.post(url, checkout, httpOptions).pipe(
      tap((data) => {
        this.state.set(STATE_KEY, data);
      }),
    );
  }
}
